import { PriceRegime } from "src/app/ui/models/domains/pbm/product-management/price-regime";
import { AbstractParser } from "../../parser";
import { parsePriceRegimes } from "./product-management-parse-funtions";

export class PriceRegimesParser extends AbstractParser<PriceRegime[]> {
  public parse(payload: any): PriceRegime[] {
    return parsePriceRegimes(payload);
  }
}
